import React, { useEffect, useState } from 'react'
import {
  MinimumRecordContainer,
  StepsContainer,
  GridContainer,
  Row,
  GridMinimumRecord,
  GridItem,
  TitleGrid,
  Divider,
  ContainerWithNumbers,
  SparkleIcon,
  HeaderContainer,
  TitleContainer,
  TitleIcon,
} from '../styled'
import { StrokedButton } from 'views/components/UI/Buttons'
import { H2, H4, P } from 'views/components/UI/Text'
import Input from 'views/components/UI/TextInput'
import Steps from 'views/components/Stepper'
import Tooltip from 'views/components/Tooltip'

import { STEPS_NEW_PROCESS } from '../../constants'
import { useTranslation } from 'react-i18next'
import { ModelSkillsProps } from '../skills'
import sparkleBlack from '../../../../../../components/assets/spark_black.png'
import skillsCleanIcon from 'assets/images/skills-clean-icon.png'

type SkillWithMinimumRecord = {
  id: number
  weight: number
}

type SkillWithMinimumRecordReformated = {
  skill_id: number
  weight: number
}

interface IMinimunRecord {
  skillSelected: any[]
  model3dSkills: ModelSkillsProps[]
  aiSkills: any[]
  onChange: (skillsWithMinimumRecord: SkillWithMinimumRecordReformated[]) => void
  onSkip: () => void
  isSavingProfile: boolean
}

const MinimumRecord = (props: IMinimunRecord) => {
  const { t } = useTranslation()

  const { skillSelected, onChange, onSkip, isSavingProfile, model3dSkills, aiSkills } = props
  const [skillsWithMinimumRecord, setSkillsWithMinimumRecord] = useState<SkillWithMinimumRecord[]>(skillSelected || [])

  useEffect(() => {
    const skillsWithMinScoreReformated = skillsWithMinimumRecord.map((item) => {
      return {
        skill_id: item.id,
        weight: item.weight,
      }
    })
    onChange(skillsWithMinScoreReformated)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [skillsWithMinimumRecord])

  const getMatchingModelNamesTooltip = (
    modelSkills: ModelSkillsProps[],
    skillName: string,
    skillId: number
  ): string => {
    const matchingNames = modelSkills
      .filter((model) => model.skills3d.some((skill3d) => skill3d.id === skillId || skill3d.name === skillName))
      .map((model) => model.name)

    if (matchingNames.length === 0) {
      return 'No se encontraron coincidencias'
    }

    return matchingNames.join(', ')
  }

  const isAiSkill = (id: number) => {
    return aiSkills.some((item) => Number(item.skill_id) === Number(id))
  }

  return (
    <MinimumRecordContainer>
      <HeaderContainer>
        <TitleContainer>
          <TitleIcon src={skillsCleanIcon} />
          <H2>Puntaje mínimo</H2>
        </TitleContainer>
        <StepsContainer>
          <Steps steps={STEPS_NEW_PROCESS} activeStep={4} />
        </StepsContainer>
      </HeaderContainer>
      <Row>
        <Row justify="space-between" margin="24px 0px 0px 0px">
          <H4 margin="30px 0px 24px 0px">{t('global.common.skillText')}</H4>
          <div>
            <Tooltip
              tooltipText="Si decides saltar este paso no podrás utilizar 9Box para este proceso"
              style={{
                marginRight: '-12px',
                transform: 'scale(1.2)',
              }}
            />
            <StrokedButton onClick={onSkip} disabled={isSavingProfile}>
              {isSavingProfile ? 'Guardando...' : 'Saltar este paso'}
            </StrokedButton>
          </div>
        </Row>
      </Row>
      <GridContainer>
        <GridMinimumRecord>
          <GridItem>
            <TitleGrid>Nombre</TitleGrid>
          </GridItem>
          <GridItem>
            <TitleGrid>Porcentaje de puntaje mínimo</TitleGrid>
          </GridItem>
        </GridMinimumRecord>
        <Divider margin="10px 0px 16px 0px" />
      </GridContainer>
      <GridMinimumRecord>
        {skillSelected.map((competence, indexItem) => (
          <React.Fragment key={indexItem}>
            <GridItem background={isAiSkill(competence.id)}>
              <ContainerWithNumbers>
                <P style={{ marginRight: '10px' }}>{indexItem + 1}.</P>
                <P style={{ fontWeight: competence.skill && competence.skill.includes('(Beta)') ? 'bold' : 'normal' }}>
                  {competence.skill}
                </P>
                {model3dSkills.length > 0 && (
                  <Tooltip
                    tooltipText={getMatchingModelNamesTooltip(model3dSkills, competence.skill, competence.id)}
                    placement="right"
                    style={{ fontSize: '14px' }}
                  />
                )}
                {aiSkills.length > 0 && isAiSkill(competence.id) && (
                  <SparkleIcon
                    style={{ marginLeft: '10px', width: '16px', height: '16px' }}
                    src={sparkleBlack}
                    alt="sparkle"
                  />
                )}
              </ContainerWithNumbers>
            </GridItem>
            <GridItem height="80px">
              <Input
                type="number"
                name={`minimumRecord-${competence.id}`}
                value={skillsWithMinimumRecord.find((item) => item.id === competence.id)?.weight || '0'}
                onChange={(e) => {
                  if (parseInt(e.target.value) > 100 || parseInt(e.target.value) < 0) {
                    return
                  } else {
                    setSkillsWithMinimumRecord((prev) => {
                      const index = prev.findIndex((item) => item.id === competence.id)
                      if (index === -1) {
                        return [...prev, { id: competence.id, weight: Number(e.target.value) }]
                      }
                      const newSkillsWithMinimumRecord = [...prev]
                      newSkillsWithMinimumRecord[index] = {
                        ...newSkillsWithMinimumRecord[index],
                        weight: Number(e.target.value),
                      }
                      return newSkillsWithMinimumRecord
                    })
                  }
                }}
                label=""
                inputProps={{ 'aria-label': `Porcentaje de puntaje mínimo de ${competence.skill}` }}
              />
            </GridItem>
          </React.Fragment>
        ))}
      </GridMinimumRecord>
    </MinimumRecordContainer>
  )
}

export default MinimumRecord
